import React from "react";

const Info = ({ error, message }) => {
	return (
		<div className="w-full flex place-items-center flex-col">
			{error && <div className="">{error}</div>}
			{message && (
				<div className="text-xl flex gap-x-4">
					<p>Tx Link:</p>
					<a href={message} className="underline">
						Etherscan
					</a>
					{/* {message && <div>{message}</div>} */}
				</div>
			)}
		</div>
	);
};

export default Info;
